import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
import { mdiTimerEdit } from "@mdi/js"
import { updateContactOrderStep } from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderStepEditPayload } from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderStepActionContext } from "../_logic/contract"
import { isStepEditable } from "../_shared/_logic/action-availability"
import ContactOrderStepOverlay from "../_modules/contact-order-step-overlay"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  row,
  order,
  step,
  stepId,
  caseId,
  contactOrderId,
  organizationId,
  contactPoints,
  customers,
  availableChannels,
  canEditStep,
  onApplyStepPatch,
  onContactOrderStepUpdated,
  onReloadContactOrders,
}: ContactOrderStepActionContext & { canEditStep: boolean }): TableRowAction[] {
  const openStepOverlay = () => {
    if (!step || !isStepEditable(step.status)) return

    openOverlay({
      title: "Ankündigungsschritt bearbeiten",
      content: ContactOrderStepOverlay,
      properties: {
        mode: "edit",
        step,
        order,
        availableChannels,
        organizationId,
        contactPoints,
        customers,
        onSave: async (payload: ContactOrderStepEditPayload) => {
          const updatedStep = await updateContactOrderStep(caseId, contactOrderId, stepId, payload)
          onContactOrderStepUpdated(contactOrderId, updatedStep)
          onApplyStepPatch(stepId, updatedStep)
          await onReloadContactOrders()
        },
      },
    })
  }
  const canShowEditStep = Boolean(
    row.isFuture && canEditStep && row.channel !== "LETTER" && isStepEditable(step?.status),
  )
  const actions: TableRowAction[] = []

  if (canShowEditStep) {
    actions.push({
      id: "action-0",

      label: "Ankündigungsschritt bearbeiten (Kanal, Fälligkeit, Notiz).",
      onClick: () => openStepOverlay(),
      icon: mdiTimerEdit,
      tooltip: "Ankündigungsschritt bearbeiten (Kanal, Fälligkeit, Notiz).",
    })
  }

  return actions
}
